/*
This file is used also during the build process to generate the
hashes for theme style elements for CSP.

When the build process is run, common vite configuration is not available, 
so make sure this file stays "vanilla".

*/
import { createVuetify } from 'vuetify';

import type { Blueprint } from 'vuetify/framework';

const defaultInputVariant = 'solo';
export const blueprint: Blueprint = {
  defaults: {
    VAppBar: {
      color: '#0043a8',
      flat: true,
    },
    VAutocomplete: {
      variant: defaultInputVariant,
    },
    VBanner: {
      color: 'primary',
    },
    VBottomSheet: {
      contentClass: 'rounded-t-xl overflow-hidden',
    },
    VBtn: {
      color: 'primary',
      rounded: 'sm',
    },
    VBtnGroup: {
      rounded: 'xl',
      VBtn: { rounded: null },
    },
    VCard: {
      rounded: 'lg',
      VCardItem: {
        VBtn: {
          color: null,
          variant: 'text',
        },
      },
      VCard: {
        variant: 'flat',
      },
    },
    VCheckbox: {
      color: 'primary',
      inset: true,
    },
    VChip: {
      rounded: 'sm',
    },
    VCombobox: {
      variant: defaultInputVariant,
    },
    VDataTable: {
      VBtn: {
        color: null,
      },
    },
    VNavigationDrawer: {
      // VList: {
      //   nav: true,
      //   VListItem: {
      //     rounded: 'xl',
      //   },
      // },
    },
    VSelect: {
      variant: defaultInputVariant,
    },
    VSlider: {
      color: 'primary',
    },
    VTabs: {
      color: 'primary',
    },
    VTextarea: {
      variant: defaultInputVariant,
    },
    VTextField: {
      variant: defaultInputVariant,
    },
    VToolbar: {
      VBtn: {
        color: null,
      },
    },
  },
  // icons: {
  //   defaultSet: 'mdi',
  //   sets: {
  //     mdi,
  //   },
  // },
  //appbar  color="#0043a8"
  theme: {
    themes: {
      light: {
        colors: {
          primary: '#436db3',
          secondary: '#FFFFFF',
          tertiary: '#7d5260',
          error: '#b3261e',
          surface: '#fffbfe',
          background: '#ecf0f5',
        },
      },
    },
  },
};

export const createVuetifyForBuild = () => {
  return createVuetify({
    blueprint,
  });
};
